import { Gift, Heart, Shield, Sparkles } from "lucide-react";

const scrollToBonus = () => {
  const element = document.querySelector("#bonus");
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
    window.history.pushState(null, "", "#bonus");
  }
};

const Hero = () => {
  return (
    <header
      className="hero-gradient relative overflow-hidden min-h-[100svh] md:min-h-screen flex items-center justify-center px-4 py-6 md:py-12 md:px-6"
      itemScope
      itemType="https://schema.org/WPHeader"
    >
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary/10 rounded-full blur-3xl animate-float motion-reduce:animate-none" />
        <div
          className="absolute -bottom-40 -left-40 w-96 h-96 bg-accent/10 rounded-full blur-3xl animate-float motion-reduce:animate-none"
          style={{ animationDelay: "2s" }}
        />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="container container-narrow text-center relative z-10">
        <div>
          {/* Badge */}
          <div className="inline-flex items-center gap-2 glass-card rounded-full px-5 py-2.5 mb-8 glow-bonus">
            <Sparkles className="w-4 h-4 text-bonus" />
            <span className="text-sm font-semibold text-bonus">
              Bonus für neue Spender {new Date().getFullYear()}
            </span>
          </div>

          {/* H1 - SEO optimized */}
          <h1
            className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 text-balance font-display"
            itemProp="headline"
          >
            <span className="text-foreground">Plasmaspenden in </span>
            <span className="text-gradient">Deutschland</span>
          </h1>

          <p className="text-xl md:text-2xl lg:text-3xl font-semibold text-bonus mb-4">
            Bis zu 150€ Anmeldebonus sichern!
          </p>

          <p className="text-lg md:text-xl text-foreground/80 font-medium mb-6">
            + ca. 30€ Aufwandsentschädigung pro Spende
          </p>

          {/* Subheadline */}
          <p
            className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed"
            itemProp="description"
          >
            Retten Sie Leben und sichern Sie sich als Neuspender attraktive
            Bonuszahlungen! Aus Ihrem Plasma werden lebensrettende Medikamente
            hergestellt. Erfahren Sie alles über die exklusiven Bonusprogramme
            bei CSL Plasma und Plasma Service Europe.
          </p>

          {/* Trust indicators */}
          <div className="flex flex-wrap justify-center gap-4 md:gap-6">
            <div className="flex items-center gap-2.5 glass-card rounded-full px-5 py-3">
              <Heart className="w-5 h-5 text-primary" />
              <span className="text-sm font-medium text-foreground">
                Leben retten
              </span>
            </div>
            <div className="flex items-center gap-2.5 glass-card rounded-full px-5 py-3">
              <Shield className="w-5 h-5 text-primary" />
              <span className="text-sm font-medium text-foreground">
                Medizinisch sicher
              </span>
            </div>
            <button
              onClick={scrollToBonus}
              className="flex items-center gap-2.5 glass-card rounded-full px-5 py-3 cursor-pointer hover:bg-primary/10 transition-colors group"
            >
              <Gift className="w-5 h-5 text-primary group-hover:scale-110 transition-transform" />
              <span className="text-sm font-medium text-foreground">
                Neuspender Bonus
              </span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
